import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import Slider from 'react-slick';
//import styled                                from '@emotion/styled';
//import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import HeaderImage from '../HeaderImage/HeaderImage';

/* eslint-disable-next-line */
import 'slick-carousel/slick/slick.css';
/* eslint-disable-next-line */
import 'slick-carousel/slick/slick-theme.css';
import './style.css';

// const ArrowContainer = styled.button`
//   border: none;
//   outline: none;
//   cursor: pointer;
//   border-radius: ${props => props.next ? '3px 0 0 3px' : '0 3px 3px 0'};
//   width: 50px;
//   height: 50px;
//   background: black;
//   opacity: 0.6;
//   color: #fff;
//   transition: opacity 0.1s;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   &:hover {
//     opacity: 1;
//   }
// `;
//
// // TODO translate aria-labels
// function NextArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     //eslint-disable-next-line
//     <div className={className}
//          style={{
//            ...style
//          }}
//          onClick={onClick}>
//       <ArrowContainer next aria-label={'Nächstes Bild'}>
//         <IoIosArrowForward style={{ height: '30px', width: '30px', color: '#fff' }}/>
//       </ArrowContainer>
//     </div>
//   );
// }
//
// function PrevArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     //eslint-disable-next-line
//     <div className={className}
//          style={{
//            ...style,
//          }}
//          onClick={onClick}>
//       <ArrowContainer aria-label={'Vorheriges Bild'}>
//         <IoIosArrowBack style={{ height: '30px', width: '30px', color: '#fff' }}/>
//       </ArrowContainer>
//     </div>
//   );
// }
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultOptions = {
  className: 'int-custom',
  dots: true,
  infinite: true,
  autoplaySpeed: 5000,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: true,
  nextArrow: null,
  prevArrow: null,
  lazyLoad: true,
  draggable: false
};

// TODO accept array of images as prop to render instead of children / alongside childen
let Carousel = /*#__PURE__*/function (_React$Component) {
  function Carousel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    return _this;
  }
  _inheritsLoose(Carousel, _React$Component);
  var _proto = Carousel.prototype;
  _proto.next = function next() {
    this.slider.slickNext();
  };
  _proto.previous = function previous() {
    this.slider.slickPrev();
  };
  _proto.render = function render() {
    const options = _objectSpread(_objectSpread({}, defaultOptions), this.props.options);
    return React.Children.count(this.props.children) === 1 ? ___EmotionJSX(HeaderImage, null, this.props.children) : ___EmotionJSX("div", null, ___EmotionJSX(Slider, _extends({}, options, {
      ref: c => this.slider = c
    }), this.props.children));
  };
  return Carousel;
}(React.Component);
export default Carousel;